import * as React from "react";
import styled, { StyledFunction } from "styled-components";

export const TableRowWrapper = styled.tr`
    & > td {
        vertical-align: middle !important;
    }
`;